import * as React from 'react'

interface HastTextNode {
  type: 'text'
  value?: string
}

interface HastElementNode {
  type: 'element'
  tagName?: string
  properties?: Record<string, unknown>
  children?: HastNode[]
}

type HastNode = HastTextNode | HastElementNode

function extractTextFromReactNode(node: React.ReactNode): string {
  if (node == null || typeof node === 'boolean') return ''
  if (typeof node === 'string' || typeof node === 'number') return String(node)
  if (Array.isArray(node)) return node.map(extractTextFromReactNode).join('')
  if (React.isValidElement(node)) return extractTextFromReactNode(node.props.children)
  return ''
}

export function extractHeadingTextFromHastNode(node: HastElementNode | null | undefined): string {
  if (!node?.children?.length) return ''

  return node.children
    .map(child => {
      if (child.type === 'text') return child.value || ''
      if (child.type === 'element' && child.tagName !== 'div') {
        return extractHeadingTextFromHastNode(child)
      }
      return ''
    })
    .join('')
    .trim()
}

export const createHeadingId = (text: string | React.ReactNode) => {
  if (typeof text !== 'string') {
    text = extractTextFromReactNode(text)
  }

  try {
    return (
      String(text)
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/[^\w-]+/g, '') // Remove non-word chars
        .replace(/--+/g, '-') // Replace multiple hyphens
        .replace(/^-+/, '') // Trim leading hyphens
        .replace(/-+$/, '') || // Trim trailing hyphens
      'heading'
    ) // Fallback if empty string
  } catch (error) {
    // Generate a random ID if all else fails
    return 'heading-' + Math.random().toString(36).substring(2, 9)
  }
}
